const FileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 384 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm48 304c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v32zm0-96c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v32zm96-210.1V128H256V0h7.9c6.4 0 12.5 2.5 17 7l97.1 97.1c4.5 4.5 7 10.6 7 17z" />
  </svg>
);

export default FileIcon;
